import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const ButtonLink = ({
  children,
  link,
  textFontFamily,
  color,
  hoverColor,
  borderRadius,
  ...otherProps
}) => (
  <ButtonWrapper
    href={link}
    target="_blank"
    rel="noopener noreferrer"
    textFontFamily={textFontFamily}
    color={color}
    hoverColor={hoverColor}
    borderRadius={borderRadius}
    {...otherProps}
  >
    {children}
  </ButtonWrapper>
);
ButtonLink.propTypes = {
  children: PropTypes.node,
  link: PropTypes.string,
  textFontFamily: PropTypes.string,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  borderRadius: PropTypes.number
};

ButtonLink.defaultProps = {
  link: '',
  textFontFamily: '"Lato", sans-serif'
};

const ButtonWrapper = styled.a`
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: auto;
  height: auto;
  padding: 8px 16px;
  margin: 0;
  font-family: ${({ textFontFamily }) => textFontFamily};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-decoration: none !important;
  color: ${({ color }) => `${color} !important`};
  border: 1px solid ${({ color }) => `${color}`};
  border-radius: ${({ borderRadius }) => `${borderRadius}px`};
  transition: color 0.2s ease-in-out, background-color 0.3s ease-in-out;
  cursor: pointer;

  :hover,
  :focus {
    color: ${({ hoverColor }) => `${hoverColor} !important`};
    background-color: ${({ color }) => `${color}`};
  }
`;

export default ButtonLink;
